import { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { BCPXmark, BCPStopwatch } from "../icons/bcp/BCPIcons";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  formControl: { backgroundColor: theme?.palette?.background.paper },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

export default function TimerPicker(props) {
  const {
    label,
    name,
    value,
    setFieldValue,
    touched,
    error,
    zIndex,
    disabled,
  } = props;
  const [open, setOpen] = useState(false);
  const [hours, setHours] = useState([]);
  const [mins, setMins] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    var hoursArray = [];
    for (var h = 0; h <= 23; h++) {
      hoursArray.push(h);
    }
    setHours(hoursArray);
    var minsArray = [];
    for (var m = 0; m <= 59; m++) {
      minsArray.push(m);
    }
    setMins(minsArray);
  }, []);

  return (
    <>
      <TextField
        label={label || "Timer Settings"}
        value={`${value?.hrs || 0}hrs ${
          value?.mins ? value.mins.toString().padStart(2, "0") : "00"
        }mins`}
        variant="outlined"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BCPStopwatch />
            </InputAdornment>
          ),
        }}
        onClick={(e) => {
          if (!disabled) {
            setOpen(true);
          }
        }}
        disabled={disabled}
      />
      <Modal
        disableAutoFocus
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          zIndex: (zIndex || 99990) + 1,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid container spacing={1} sx={{ pt: 2 }}>
            <Grid item xs={6}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                sx={{ mt: 2, mb: 1 }}
              >
                <InputLabel id={`${name}-hrs`}>Hours</InputLabel>
                <Select
                  error={Boolean(touched && error)}
                  fullWidth
                  helperText={touched && error}
                  labelId={`${name}-hrs`}
                  name={`${name}.hrs`}
                  value={value?.hrs}
                  onChange={(e) => {
                    setFieldValue(`${name}.hrs`, e.target.value);
                  }}
                  label="Hours"
                  variant="outlined"
                  MenuProps={{
                    sx: { zIndex: `${(zIndex || 99990) + 2} !important` },
                  }}
                >
                  {hours.map((h) => (
                    <MenuItem key={h} value={h}>
                      {h}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                sx={{ mt: 2, mb: 1 }}
              >
                <InputLabel id={`${name}-mins`}>Minutes</InputLabel>
                <Select
                  error={Boolean(touched && error)}
                  fullWidth
                  helperText={touched && error}
                  labelId={`${name}-mins`}
                  name={`${name}.mins`}
                  value={value?.mins}
                  onChange={(e) => {
                    setFieldValue(`${name}.mins`, e.target.value);
                  }}
                  label="Minutes"
                  variant="outlined"
                  MenuProps={{
                    sx: { zIndex: `${(zIndex || 99990) + 2} !important` },
                  }}
                >
                  {mins.map((m) => (
                    <MenuItem key={m} value={m}>
                      {m}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}
